import useSWR from 'swr';
import { supabase } from '../../supabase';
import dayjs from 'dayjs';

const fetchAvisosAutomaticos = async () => {
  const hoy = dayjs().format('YYYY-MM-DD');
  const hasta = dayjs().add(5, 'day').format('YYYY-MM-DD');

  const { data, error } = await supabase
    .from('vencimientos')
    .select(
      `
      id,
      fecha_vencimiento,
      notificar,
      pagado,
      servicios (
        tipo_servicio,
        empresa_proveedora,
        titular,
        detalle,
        referencia_cuenta
      )
    `
    )
    .eq('notificar', true)
    .eq('pagado', false)
    .gte('fecha_vencimiento', hoy)
    .lte('fecha_vencimiento', hasta)
    .order('fecha_vencimiento', { ascending: true });

  if (error) throw error;

  return data || [];
};

export const useAvisosAutomaticos = () => {
  const { data, error, isLoading, mutate } = useSWR(
    'avisos:automaticos',
    fetchAvisosAutomaticos,
    {
      refreshInterval: 300000,
      revalidateOnFocus: true,
    }
  );

  return {
    avisos: data || [],
    loading: isLoading,
    error,
    mutate,
  };
};